import { render, staticRenderFns } from "./CompanyInformationLoader.vue?vue&type=template&id=0f047d23&scoped=true&"
var script = {}
import style0 from "./CompanyInformationLoader.vue?vue&type=style&index=0&id=0f047d23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f047d23",
  null
  
)

export default component.exports